import { localize } from '../helpers';

type Service = {
    instruction?: string;
    instructionTitle?: string;
    nameServices?: string;
    link?: string;
    method?: string;
    params?: string;
    paramsTitle?: string;
    headers?: string;
    requestBody?: string;
    titleBody?: string;
    resultExample?: string;
    resultExampleInstruction?: string;
    isLSService?: boolean;
};

export const templates = (translations: Record<string, string>, module: string) => {
    const data: Record<string, Service | Array<Service>> = {
        findNdsPayer: [
            {
                nameServices:
                    localize('find-nds-payer-service-search-vat-data', translations) + ':',
                link: '[portal-host]/services/isnaportalsync/public/search-payer-data',
                method: 'GET',
                params: `{
     taxpayerCode: "ИИН/БИН"
} `,
                resultExample: `{
    "iinBin": "ИИН/БИН",
    "nameRu": "Наименование НП на русском",
    "nameEn": "Наименование НП на английском", 
    "nameKz": "Наименование НП на казахском",
    "ndsRegistrationDate": "Дата постановки (последней постановки на учет по НДС)",
    "ndsDeregistrationDate": "Дата снятия (последнего снятия) с учета НДС",
    "ndsDeregistrationReason": {
        "code": "Код причины снятия",
        "ru": "Причина снятия на русском",
        "kk": "Причина снятия на казахском",
        "en": "Причина снятия на английском",
        "qq": "Причина снятия на латинском казахском",
    }
}`,
            },
            {
                nameServices: 'Проверка на соответствие номера и серии свидетельства НДС',
                link: '[portal-host]/services/isnaportalsync/public/check-certificate-number-and-series-for-compliance',
                params: `{
   taxpayerCode: "ИИН/БИН",
   number: "Номер свидетельства",
   series: "Серия свидетельства"
}`,
                resultExample: `{
    "responseMessageId": "ID сообщения ответа",
    "statusCode": "статус сообщения",
    "responseType": "2",
    "messageRu": "текст сообщения на Русском",
    "messageKz": "текст сообщение на Казахском",
    "responseDate": "дата запроса",
    "receiverData": {
        "company": "Наименование организаций",
        "bin": "БИН",
        "informationSystem": "Наименование системы"
    },
    "responseData": {
        "iinBin": "ИИН/БИН",
        "nameRu": "Наименование на Русском",
        "nameEn": "Наименование на Английском",
        "nameKz": "Наименование на Казахском",
        "ndsRegistrationDate": Дата постановки (последней постановки на учет по НДС),
        "ndsDeregistrationDate": Дата постановки (последней постановки на учет по НДС),
        "ndsDeregistrationReason": Причина снятия (последнего снятия) с учета по НДС
    },
    "certificateInfoData": {
        "number": "Номер сертификата",
        "beginDate": "Дата начала",
        "series": "Серия сертификата",
        "status": "Статус сертификата",
        "requestMessageId": "ID сообщения запроса"
    }
}`,
            },
        ],
        ServiceUnreliableTaxpayers: {
            nameServices: 'Поиск неблагонадежных НП:',
            link: '[portal-host]/services/isnaportal/public/taxpayer-data/search',
            method: 'POST',
            params: `{
    "taxPayerCode": "ИИН/БИН НП",
    "language": "Язык запроса",
    "rnn": "РНН НП",
    "taxPayerOrgName": "Наименование Организаций НП",
    "directorIin": "ИИН Директора",
    "firstName": "ИМЯ НП",
    "lastName": "ФАМИЛИЯ НП",
    "middleName": "ОТЧЕСТВО НП"
}`,
            resultExample: `[
    {
        "iin": "ИИН/БИН НП",
        "rnn": "РНН НП",
        "name": "Наименование НП",
        "fullName": "ФИО, если нету то Наименование НП",
        "directorFullName": "ФИО Директора",
        "directorIin": "ИИН Директора",
        "directorRnn": "РНН Директора",
        "taxpayerDataList": [
            {
                "unreliableTaxpayerDataCategory": "Наименование категорий к которому относится НП",
                "taxOrgCode": "код ОГД",
                "dataReportDate": "Дата приказа",
                "actType": "Тип Акта",
                "actNumber": "Номер акта обследования",
                "actCreateDate": "Дата акта обследования"
            }
        ]
    }
]`,
        },
        FindTaxpayerService: [
            {
                nameServices: localize('api-search-tp', translations),
                link: '[portal-host]/services/isnaportalsync/public/taxpayer-data',
                method: 'GET',
                paramsTitle: 'Индивидуальный предприниматель:',
                params:
                    '<div>taxpayerCode: <ИИН/БИН></div>' +
                    '<div>taxpayerType: IP</div>' +
                    '<div>name: <Наименование ИП></div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "IP",
            "fullName": "string or null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
            {
                paramsTitle: 'Юридическое лицо:',
                params:
                    '<div>taxpayerCode: <БИН></div>' +
                    '<div>taxpayerType: UL & UL_NR</div>' +
                    '<div>name: <Наименование организации></div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "UL",
            "fullName": "null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
            {
                paramsTitle: 'Лицо, занимающееся частной практикой:',
                params:
                    '<div>taxpayerCode: <ИИН></div>' +
                    '<div>firstName: <Имя></div>' +
                    '<div>lastName: <Фамилия></div>' +
                    '<div>taxpayerType: LZCHP</div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "LZCHP",
            "fullName": {
                "lastName": "string",
                "firstName": "string",
                "middleName": "string"
            },
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
        ],
        FindLiquidatedTaxpayer: {
            nameServices: 'Поиск НП на стадии ликвидации:',
            link: '[portal-host]/services/isnaportalsync/public/find-liquidated-taxpayer',
            method: 'GET',
            params: `{
    "taxpayerCode": "ИИН/БИН НП",
    "name": "Наименование НП",
    "fio": "ФИО НП",
    "date": "Дата поиска",
    "page" : "Номер страницы",
    "pageSize" : "Размер страницы"
}`,
            resultExample: `{
    "taxpayers": {
        "content": [
            {
                "ru": "Наименование НП на русском",
                "kk": "Наименование НП на казахском",
                "en": "Наименование НП на английском",
                "qq": "Наименование НП на казахской латинице",
                "rnn": "РНН НП",
                "iinBin": "ИИН НП",
                "firstName": "Имя НП",
                "lastName": "Фамилия НП",
                "middleName": "Отчество НП",
                "beginDate": "Дата начала Ликвидаций",
                "type": "Тип НП"
            }
        ],
        "pageNumber": "Номер страницы (начало с 0)",
        "pageSize": "Размер страницы от 1 до 100",
        "numberOfElements": "Количество элементов",
        "lastPage": true,
        "empty": false
    },
    "status": "код статуса",
    "message": {
        "nameRu": "Сообщение на русском",
        "nameKk": "Сообщение на казахском",
        "nameQq": "Сообщение на казахской латинице",
        "nameEn": "Сообщение на английском"
    }
}`,
        },
        FindRiskDegreeService: {
            nameServices: localize('api-risk-degree-category', translations),
            link: '[portal-host]/services/isnaportalsync/public/find-risk-degree',
            method: 'GET',
            params: localize('api-print-taxpayerCode', translations),
            resultExample: `{
    "taxpayerCode" : "iinBin",
    "name" : "NP name",
    "degree" : "degreeCode",
    "relevanceDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "beginDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "endDate" : "yyyy-mm-ddT00:00:00.000+00:00"
}`,
        },
        InfoAbsenceTaxDebt: {
            isLSService: true,
            nameServices: 'Cведения об отсутствии (наличии) налоговой задолженности:',
            link: '[portal-host]/services/isnaportalsync/public/tax-debt-info',
            method: 'GET',
            params: `taxpayerCode: <ИИН/БИН налогоплательщика>
personalAccountToken: <Токен ЛС>`,
            resultExample: `{
  "iinBin": "ИИН/ БИН налогоплательщика, по которому предоставляются сведения",
  "totalArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по всем ОГД, типам платежа и КБК.",
  "totalTaxArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по всем ОГД, типам платежа и КБК за исключением задолженности по КБК 901101, 903101, 905101 (обязательные пенсионные взносы), 902101 (социальные отчисления), 904101 (отчисления и взносы по ОМС)",
  "pensionContributionArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по всем ОГД, типам платежа по КБК 901101, 903101 и 905101",
  "socialContributionArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по всем ОГД, типам платежа только по КБК 902101.",
  "socialHealthInsuranceArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по всем ОГД, типам платежа только по КБК 904101.",
  "taxOrgInfos": [
    {
      "charCode": "6-изначный код ОГД, в котором имеется задолженность.",
      "nameRu": "Наименование налогового органа на русском языке",
      "nameKz": "Наименование налогового органа на казахском языке",
      "reportAcrualDate": "Текущая календарная дата, на которую рассчитывается задолженность",
      "totalArrear": "Агрегированная сумма задолженности по всем НП в данном ОГД.",
      "totalTaxArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по указанному ОГД, типам платежа и КБК за исключением задолженности по КБК 901101, 903101, 905101 (обязательные пенсионные взносы), 902101 (социальные отчисления), 904101 (отчисления и взносы по ОМС) в данном ОГД.",
      "pensionContributionArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по указанному ОГД, типам платежа по КБК 901101, 903101 и 905101 в данном ОГД.",
      "socialContributionArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по указанному ОГД, типам платежа по КБК 902101 в данном ОГД.",
      "socialHealthInsuranceArrear": "Агрегированная сумма задолженности НП и его структурных подразделений по указанному ОГД, типам платежа по КБК 904101 в данном ОГД.",
      "taxpayerInfo": {
        "iinBin": "ИИН/ БИН налогоплательщика или его структурного подразделения, по которому предоставляются сведения.",
        "nameRu": "ФИО или наименование налогоплательщика на русском языке",
        "nameKz": "ФИО или наименование налогоплательщика на казахском языке",
        "bccArrearsInfos": [
          {
            "bcc": "Код бюджетной классификации (КБК)",
            "bccNameRu": "Наименование КБК лицевого счета, по которому имеется задолженность по НП или его структурное подразделение в данном ОГД.",
            "bccNameKz": "Наименование КБК лицевого счета, по которому имеется задолженность по НП или его структурное подразделение в данном ОГД.",
            "taxArrear": "Передается сумма задолженности по налогу, округленная и умноженная на (-1).",
            "poenaArrear": "Передается сумма задолженности по пене, округленная и умноженная на (-1).",
            "percentArrear": "Передается сумма задолженности по процентам, округленная и умноженная на (-1).",
            "fineArrear": "Передается сумма задолженности по штрафу, округленная и умноженная на (-1).",
            "totalArrear": "Общая сумма задолженностей по налогу, пене, штрафу и процентам, округленная до 2-х знаков после запятой."
          }
        ],
        "taxArrear": "Агрегированная сумма задолженности по налогу НП или его структурного подразделения по всем КБК в данном ОГД.",
        "poenaArrear": "Агрегированная сумма задолженности по пени НП или его структурного подразделения по всем КБК в данном ОГД.",
        "percentArrear": "Агрегированная сумма задолженности по процентам НП или его структурного подразделения по всем КБК в данном ОГД.",
        "fineArrear": "Агрегированная сумма задолженности по штрафам НП или его структурного подразделения по всем КБК в данном ОГД.",
        "totalArrear": "Агрегированная сумма задолженности по всем типам платежа НП или его структурного подразделения по всем КБК в данном ОГД."
      }
    }
  ]
}`,
        },
        BankruptService: [
            {
                nameServices:
                    'Поиск Список должников, в отношении которых вступили в законную силу решение суда о признании их банкротами, применении реабилитационной процедуры',
                link: '[portal-host]/services/isnaportal/public/bankrupt-service/debtors/all',
                method: 'POST',
                params: `{
    "header": {
        "messageId": "Уникальный идентификатор сообщения. Обязательное поле",
        "sender": "Идентификатор системы-отправителя. Обязательное поле"
    },
    "procedureType": "Тип процедуры (например, REHABILITATION). Обязательное поле"
}`,
                resultExample: `{
  "header": {
    "messageId": "Уникальный идентификатор сообщения",
    "responseId": "Уникальный идентификатор ответа",
    "responseDate": "Дата и время формирования ответа"
  },
  "response": [
    {
      "debtorData": {
        "identifier": "ИИН или БИН должника",
        "rnn": "Регистрационный номер налогоплательщика (РНН) должника",
        "debtorName": "Наименование или ФИО должника",
        "debtorNameRu": "Наименование или ФИО должника на русском языке",
        "debtorNameKk": "Наименование или ФИО должника на казахском языке",
        "activityRu": "Описание вида деятельности должника на русском языке",
        "activityKk": "Описание вида деятельности должника на казахском языке",
        "regionRu": "Наименование региона регистрации на русском языке",
        "regionKk": "Наименование региона регистрации на казахском языке",
        "procedureType": "Тип процедуры (например, REHABILITATION)"
      },
      "admin": {
        "email": "Адрес электронной почты администратора",
        "firstName": "Имя администратора",
        "lastName": "Фамилия администратора",
        "middleName": "Отчество администратора",
        "fullName": "Полное ФИО администратора одной строкой",
        "phone": "Контактный телефон администратора",
        "adminAddress": {
          "nameRu": "Полный адрес администратора на русском языке",
          "nameKk": "Полный адрес администратора на казахском языке",
          "nameQq": "Полный адрес администратора на альтернативном языке (QQ)",
          "nameEn": "Полный адрес администратора на английском языке"
        }
      },
      "directorData": [
        {
          "memberType": "Тип должностного лица (например, DIRECTOR)",
          "identifier": "ИИН руководителя",
          "lastName": "Фамилия руководителя",
          "firstName": "Имя руководителя",
          "middleName": "Отчество руководителя",
          "name": "ФИО руководителя одной строкой",
          "nameRu": "ФИО руководителя на русском языке",
          "nameKk": "ФИО руководителя на казахском языке"
        }
      ],
      "founderData": [
        {
          "memberType": "Тип участника (например, FOUNDER)",
          "identifier": "ИИН или БИН учредителя",
          "lastName": "Фамилия учредителя",
          "firstName": "Имя учредителя",
          "middleName": "Отчество учредителя",
          "name": "Наименование или ФИО учредителя одной строкой",
          "nameRu": "Наименование или ФИО учредителя на русском языке",
          "nameKk": "Наименование или ФИО учредителя на казахском языке"
        }
      ],
      "entryForceDate": "Дата вступления решения в законную силу (DD.MM.YYYY)",
      "issueDate": "Дата вынесения решения (DD.MM.YYYY)"
    }
  ]
}`,
            },
        ],
        'taxpayer-accruals': {
            isLSService: true,
            nameServices:
                'Поиск данных о начислениях на налогоплательщика земля, имущество, транспорт:',
            link: '[portal-host]/services/isnaportalsync/public/personal-account-accrual',
            method: 'POST',
            paramsTitle: 'Входные параметры',
            params: `Не ФЛ
{
    "personalAccountToken":"<Токен ЛС>",
    "bin": "<БИН>",
    "rnn": "<РНН>"(необязательно)
}
\n
Для ФЛ
{
    "personalAccountToken":"<Токен ЛС>",
    "inn": "<ИИН>",
    "signedRequest": "<Данные с ЭЦП при запросе ФЛ>"
} 
 `,
            resultExample: `{
    "err": {
        "error": "Сообщение ошибки",
        "errorCode": "код ошибки"
    },
    "iinbin": "ИИН/БИН",
    "rnn": "РНН",
    "nameRu": "Наименование на русском",
    "nameKz": "Наименование на казахском",
    "items": [
        {
            "taxOrgCode": "Номер ОГД",
            "nameTaxRu": "Наименование ОГД",
            "nameTaxKz": "МКО атауы",
            "kbk": "номер КБК",
            "kbkNameRu": "Наименование КБК",
            "kbkNameKz": "БЖК атауы",
            "docType": "Тип документа",
            "docNameRu": "Наименование документа на русском",
            "docNameKz": "Наименование документа на казахском",
            "chargeType": "Тип начисления",
            "chargeDocType": "Тип документа с начислениями",
            "docNum": "Номер документа",
            "applyDate": "Срок уплаты",
            "summa": "Сумма",
            "docStatus": "Код статуса документа",
            "vinCode": "Код ВИН",
            "cadNum": "Кадастровый номер"
        }
    ]
}`,
        },
        'excessive-paid-service': {
            isLSService: true,
            nameServices: 'Сервис по приему заявлений излишне (ошибочно) оплаченных сумм налогов:',
            link: '[portal-host]/services/isnaportalsync/public/excessive-paid',
            method: 'POST',
            params: `{
    "personalAccountToken":"<Токен ЛС>",
    "kbk":"<КБК>",
    "taxOrgCode":"<Код ОГД>",
    "taxpayerCode":"<ИИН/БИН>",
    "signedRequest": "<Данные с ЭЦП>"
}`,
            resultExample: `{
    "iinbin": "ИИН или БИН налогоплательщика (12 цифр)",
    "taxOrg": "Код органа государственных доходов",
    "kbk": "Код бюджетной классификации (КБК)",
    "operationDate": "Дата совершения операции",
    "persAccOPA": {
        "sumOPATax": "Сумма основной задолженности",
        "sumOPAPenalty": "Сумма начисленной пени",
        "sumOPAPercent": "Сумма начисленных процентов",
        "sumOPAFine": "Сумма административных штрафов"
    },
    "error": {
        "errorCode": "Код статуса обработки запроса",
        "errorCodeNameRu": "Текстовое описание статуса обработки на русском языке",
        "errorCodeNameKz": "Текстовое описание статуса обработки на казахском языке"
    },
    "reqID": "Уникальный идентификатор запроса в системе",
    "reqDate": "Дата и время формирования запроса"
}`,
        },
        'paid-amounts-service': {
            isLSService: true,
            nameServices:
                'Сервис по предоставлению информации об уплаченных суммах на лицевом счете налогоплательщика',
            link: '[portal-host]/services/isnaportalsync/public/payments',
            method: 'POST',
            params: `{
    "personalAccountToken":"<Токен ЛС>",
    "taxpayerCode":"<ИИН/БИН>",
    "signedRequest": "<Данные с ЭЦП>"
}`,
            resultExample: `{
    "iinbin": "ИИН/ БИН налогоплательщика, по которому предоставляются сведения.",
    "taxOrg": "Код органа государственных доходов",
    "kbk": "Код бюджетной классификации (КБК)",
    "operationDate": "Дата совершения операции",
    "persAccOPA": {
        "sumOPATax": "Сумма основного налога по лицевому счету",
        "sumOPAPenalty": "Сумма начисленной пени по лицевому счету",
        "sumOPAPercent": "Сумма начисленных процентов по лицевому счету",
        "sumOPAFine": "Сумма наложенных штрафов по лицевому счету"
    },
    "error": {
        "errorCode": "Код ошибки обработки запроса",
        "errorCodeNameRu": "Описание ошибки обработки на русском языке",
        "errorCodeNameKz": "Описание ошибки обработки на казахском языке"
    },
    "reqID": "IID запроса",
    "reqDate": "Дата время отправки сообщения"
}`,
        },
        'register-creditors': {
            nameServices:
                'Поиск Реестра требований кредиторов в процедурах реабилитации и банкротства:',
            link: '[portal-host]/services/isnaportal/public/bankrupt-service/rtk',
            method: 'POST',
            params: `{
  "header": {
    "messageId": "идентификатор сообщения",
    "sender": "идентификатор системы"
  }
}`,
            resultExample: `{
  "header": {
    "messageId": "уникальный идентификатор сообщения",
    "responseId": "уникальный идентификатор ответа",
    "responseDate": "дата и время формирования ответа"
  },
  "response": [
    {
      "debtor": {
        "identifier": "БИН или ИИН дебитора",
        "claimedAmount": "общая сумма заявленных требований",
        "recognizedAmount": "общая сумма признанных требований",
        "unrecognizedAmount": "общая сумма непризнанных требований",
        "debtOriginationDate": "дата возникновения задолженности",
        "justificationDocName": "наименование и реквизиты подтверждающих документов"
      },
      "rtkQueue": {
        "1_queue": {
          "lifeAndHealthDamageAmount": "сумма возмещения вреда жизни и здоровью",
          "alimonyAmount": "сумма задолженности по алиментам",
          "salaryAndCompensationAmount": "задолженность по оплате труда и компенсациям",
          "socialContributionsAmount": "задолженность по социальным отчислениям",
          "pensionContributionsAmount": "задолженность по пенсионным взносам",
          "medicalInsuranceAmount": "задолженность по медицинскому страхованию",
          "authorRewardsAmount": "вознаграждения по авторским договорам"
        },
        "2_queue": {
          "securedByPledgeAmount": "требования, обеспеченные залогом имущества",
          "bankruptcyLoanAmount": "задолженность по кредитам, выданным в период процедуры",
          "clearingHouseAmount": "требования по расчетам клиринговых организаций"
        },
        "3_queue": {
          "taxDebtAmount": "задолженность по налогам",
          "customsDebtAmount": "задолженность по таможенным платежам"
        },
        "4_queue": {
          "civilLawObligationsAmount": "требования по гражданско-правовым обязательствам",
          "unsecuredPledgeAmount": "необеспеченная часть залоговых требований",
          "authorContractsAmount": "обязательства по авторским правам",
          "invalidatedTransactionsAmount": "требования по сделкам, признанным недействительными",
          "pledgeTransferDifferenceAmount": "разница между стоимостью залога и обязательством"
        },
        "5_queue": {
          "penaltiesAndFinesAmount": "сумма неустоек, штрафов и пеней",
          "lossesAmount": "сумма убытков в виде упущенной выгоды"
        },
        "6_queue": {
          "lateFilingClaimsAmount": "требования, заявленные после истечения срока регистрации"
        },
        "7_queue": {
          "subordinatedDebtAmount": "требования по субординированным долгам"
        }
      }
    }
  ]
}`,
        },

        'service-find-admin': {
            nameServices: 'Поиск Список лиц имеющих право осуществлять деятельность Администратора',
            link: '[portal-host]/services/isnaportal/public/bankrupt-service/admins',
            method: 'POST',
            params: `{
  "fullName": "string", (обязательное поле)
  "address": "string",
  "beginDateFrom": "string",
  "beginDateTo": "string",
  "certificate": "string",
  "closedBankruptcyCountFrom": 0,
  "closedBankruptcyCountTo": 0,
  "closedRehabilitationCountFrom": 0,
  "closedRehabilitationCountTo": 0,
  "date": "string",
  "email": "string",
  "existingBankruptcyCountFrom": 0,
  "existingBankruptcyCountTo": 0,
  "existingRehabilitationCountFrom": 0,
  "existingRehabilitationCountTo": 0,
  "experienceFrom": 0,
  "experienceTo": 0,
  "inspectionCountFrom": 0,
  "inspectionCountTo": 0,
  "otherDocument": "string",
  "phone": "string"
}`,
            resultExample: `{
  "bankruptcy": {
    "amountAdministrativeExpensesSum": 0,
    "amountReceivedBankruptcySum": 0,
    "closedBankruptcyTotal": 0,
    "includingPropertyBankruptcySum": 0,
    "instatedClaimsBankruptcySum": 0,
    "satisfiedClaimsBankruptcySum": 0
  },
  "beginDate": "string",
  "certificates": [
    {
      "issueDate": "2025-10-31T12:25:02.431Z",
      "issueOrg": "string",
      "name": "string",
      "number": "string",
      "type": "string"
    }
  ],
  "contacts": {
    "address": {
      "nameEn": "string",
      "nameKk": "string",
      "nameQq": "string",
      "nameRu": "string"
    },
    "email": "string",
    "phone": "string",
    "secondEmail": "string",
    "secondPhone": "string",
    "thirdEmail": "string",
    "thirdPhone": "string"
  },
  "documents": [
    {
      "issueDate": "2025-10-31T12:25:02.431Z",
      "issueOrg": "string",
      "name": "string",
      "number": "string",
      "type": "string"
    }
  ],
  "endDate": "string",
  "experience": 0,
  "experienceBeginDate": "string",
  "experienceEndDate": "string",
  "firstName": "string",
  "fullName": "string",
  "iin": "string",
  "lastName": "string",
  "middleName": "string",
  "rehabilitation": {
    "achievedClosedRehabilitationCount": 0,
    "actionsCauseDamagedRehabilitationCount": 0,
    "closedRehabilitationTotal": 0,
    "monetaryObligationsRehabilitationCount": 0,
    "notifiedClosedRehabilitationCount": 0,
    "resultsCauseDamageRehabilitationCount": 0
  }
} `,
        },
        'service-list-persons-on-termination-rehabilitation': {
            nameServices:
                'Поиск Список ИП и ЮЛ, в отношении которых вступило в законную силу определение суда о прекращении реабилитационной процедуры',
            link: '[portal-host]/services/isnaportal/public/bankrupt-service/debtors',
            method: 'POST',
            params: `{
  "header": {
    "messageId": "идентификатор сообщения",
    "sender": "идентификатор системы"
  }
}`,
            resultExample: `{
  "header": {
    "messageId": "уникальный идентификатор сообщения",
    "responseId": "уникальный идентификатор ответа",
    "responseDate": "дата и время формирования ответа"
  },
  "response": [
    {
      "debtorData": {
        "identifier": "бин организации или иин физического лица",
        "rnn": "регистрационный номер налогоплательщика если есть",
        "debtorName": "полное имя должника для физических лиц",
        "debtorNameRu": "наименование компании на русском языке",
        "debtorNameKk": "наименование компании на казахском языке",
        "activityRu": "вид деятельности на русском языке",
        "activityKk": "вид деятельности на казахском языке",
        "regionRu": "регион нахождения на русском языке",
        "regionKk": "регион нахождения на казахском языке",
        "procedureType": "тип процедуры например реабилитация или банкротство"
      },
      "debtorMembers": [
        {
          "memberType": "роль участника например учредитель директор или бухгалтер",
          "identifier": "иин или бин участника",
          "lastName": "фамилия участника",
          "firstName": "имя участника",
          "middleName": "отчество участника при наличии",
          "name": "полное фио одной строкой",
          "nameRu": "название организации участника на русском",
          "nameKk": "название организации участника на казахском"
        }
      ],
      "caseAdminData": {
        "type": "код типа администратора или управляющего",
        "identifier": "иин администратора",
        "adminName": "полное фио управляющего",
        "phone": "контактный номер телефона",
        "email": "адрес электронной почты",
        "addressRu": "полный адрес на русском языке",
        "addressKk": "полный адрес на казахском языке"
      },
      "courtDecision": {
        "issueDate": "дата вынесения судебного решения",
        "entryForceDate": "дата вступления решения в законную силу",
        "status": "текущий статус дела например процедура завершена"
      }
    }
  ]
}`,
        },
        'find-ads': {
            nameServices: 'Поиск объявлений',
            link: '[portal-host]/services/isnaportal/public/bankrupt-service/announcements',
            method: 'POST',
            params: `{
  "header": {
    "messageId": "идентификатор сообщения",
    "sender": "идентификатор системы"
  }
}`,
            resultExample: `{
  "header": {
    "messageId": "уникальный идентификатор сообщения",
    "responseId": "уникальный идентификатор ответа",
    "responseDate": "дата и время формирования ответа"
  },
  "response": [
    {
      "advertisingDate": "дата публикации объявления",
      "messageType": "тип системного сообщения",
      "debtor": {
        "identifier": "БИН организации или ИИН физического лица должника",
        "courtDecisionInfo": "дополнительная информация о судебном решении внутри объекта должника",
        "rnn": "РНН должника (если имеется)",
        "addressRu": "полный адрес должника на русском языке",
        "addressKk": "полный адрес должника на казахском языке"
      },
      "courtDecisionInfo": {
        "courtNameRu": "наименование суда на русском языке",
        "courtNameKk": "наименование суда на казахском языке",
        "proceedingsInitiationDate": "дата возбуждения производства по делу",
        "liquidationDecisionDate": "дата вынесения решения о ликвидации"
      },
      "creditorClaim": {
        "claimsAcceptanceDeadline": "срок приема претензий кредиторов",
        "claimsSubmissionAddress": "адрес для подачи заявлений от кредиторов",
        "creditorMeetingInfo": "дополнительная информация для кредиторов",
        "meetingDate": "дата проведения собрания кредиторов (ГГГГ-ММ-ДД)",
        "meetingTime": "время проведения собрания (ЧЧ:ММ)",
        "meetingLocation": "точное место проведения собрания кредиторов",
        "meetingAgenda": "повестка дня собрания"
      },
      "caseAdminData": {
        "type": "код типа администратора/управляющего",
        "identifier": "ИИН администратора/управляющего",
        "adminName": "полное ФИО управляющего",
        "phone": "контактный номер телефона управляющего",
        "email": "адрес электронной почты управляющего",
        "addressRu": "адрес местонахождения управляющего на русском языке",
        "addressKk": "адрес местонахождения управляющего на казахском языке"
      }
    }
  ]
}`,
        },
        'event-data': [
            {
                instructionTitle: `Инструкция по получению токена`,
                instruction: `Для того, чтобы получить токен необходимо выполнить следующие шаги:<br />
1. Зарегистрироваться в систему через ЭЦП ключ или авторизоваться (если имеется учетная запись)<br /> 
2. После успешной авторизации перейти в сервис и нажать на кнопку “Ссылка на API”<br /> 
3. Далее нажать на кнопку “Создать обращение” и заполнить форму для получения токена<br /> 
<br />
Для получения сведений по должнику, необходимо запустить нижеуказанный API. Потребуются следующие данные: токен (выше инструкция как получить ключ) и ИИН/БИН должника.`,
                nameServices: 'Получения сведений по должнику',
                link: '[portal-host]/services/isnaportal/public/bankrupt-service/event-data',
                method: 'POST',
                headers: `Key - X-Portal-Token
Value - d0b1e1d5-6d8a-493c-8240-435c1e743b04 //токен`,
                titleBody: 'Тело запроса: JSON-объект вида:',
                requestBody: `{
    "iin_bin": "ИИН/БИН",
}`,
                resultExampleInstruction: `Тип события с датами и прочими данными по запрашиваемому должнику.`,
                resultExample: `[
    {
        "iin_bin": "ИИН/БИН должника",
        "event_type": "Код события",
        "event_date": "Дата определение о возбуждении дела",
        "entryforce_date": "Дата вступления в силу"
    },
    {
        "iin_bin": "ИИН/БИН должника",
        "event_type": "Код события",
        "event_date": "Дата и время проведения собрания кредиторов",
        "agenda": "Повестка дня собрания кредиторов (текст)",
        "creditor_meeting_place": {
            "nameRu": "Место провидения собрания на русском",
            "nameKk": "Место провидения собрания на казахском",
            "nameQq": "Место провидения собрания на казахской латинице",
            "nameEn": "Место провидения собрания на английском"
        }
    },
    {
        "iin_bin": "ИИН/БИН администратора",
        "event_type": "Код события",
        "event_date": "Дата начала администрирования",
        "admin_type": {
            "nameRu": "Тип администратора на русском",
            "nameKk": "Тип администратора на казахском",
            "nameQq": "Тип администратора на казахской латинице",
            "nameEn": "Тип администратора на английском"
        }
    }
]`,
            },
        ],

        'service-citizens-judicial-bankruptcy': [
            {
                nameServices:
                    'Сервиса получения данных списка граждан, в отношении которых вступили в законную силу соответствующие определения и решения судов',
                link: `<p>[portal-host]/services/isnaportal/public/bankrupt-service/tazalau/citizens-judicial-bankruptcy?page=0&size=100</p>
<p>Пагинация в URL сервиса <br /> page = Номер страницы <br /> size = Размер страницы</p>`,
                params: `{
  "header": {
    "messageId": "идентификатор сообщения",
    "sender": "идентификатор системы"
  }
} `,
                resultExample: `{
    "header":{
         "messageId": "уникальный идентификатор сообщения",
         "responseId": "уникальный идентификатор ответа",
         "responseDate": "дата и время формирования ответа"
},
    "response": {
        "content": [
           {
                 "iin": "ИИН физического лица",
                 "fio": "ФИО физического лица",
                 "statementNumber": "Уникальный номер заявления физического лица о применении процедуры банкротства от фронт системы",
                 "bankruptcyType": "Тип процедуры банкротства",
                 "statementApplicationDate": "Дата подачи заявления от фронт системы",
                 "statementRegDate": "Дата регистрации заявления в системе Tazalau",
                 "statementAcceptDate": "Дата принятия заявления/иска(дата публикации должника)",
                 "refusalDate": "Дата отказа в применении процедуры",
                 "proceedingsStartDate": "Дата возбуждения производства по делу",
                 "courtDecisionDate": "Дата решения суда о применении процедуры судебного банкротства",
                 "terminationDate": "Дата прекращения процедуры",
                 "bankruptStartDate": "Дата признания банкротом ",
                 "bankruptEndDate": "Дата завершения банкротства  ",
                 "lastModificationDate": "Дата актуальности данных",
                 "statementStatus": "Статус заявления физического лица",
                 "rowVersion": "Версия актуальности данных",
                 "citizenStatus": "Статус гражданина",
                 "terminationReasons": [Причины прекращения процедуры],
                 "bankruptEndReasons": [Причины завершения банкротства]
               }
         ]
     }
}`,
            },
        ],

        'service-citizens-non-judicial-bankruptcy': [
            {
                nameServices:
                    'Сервис получения данных списка граждан, в отношении которых применена, прекращена и завершена процедура внесудебного банкротства',
                link: `<p>[portal-host]/services/isnaportal/public/bankrupt-service/tazalau/citizens-non-judicial-bankruptcy?page=0&size=100</p>
<p>Пагинация в URL сервиса<br/> page = Номер страницы <br/>size = Размер страницы</p>`,
                params: `{
    "header": {
        "messageId": "идентификатор сообщения",
        "sender": "идентификатор системы"
    }
}`,
                resultExample: `{
  "header": {
    "messageId": "уникальный идентификатор сообщения",
    "responseId": "уникальный идентификатор ответа",
    "responseDate": "дата и время формирования ответа"
  },
  "response": {
    "content": [
      {
        "iin": "ИИН физического лица",
        "fio": "ФИО физического лица",
        "statementNumber": "Уникальный номер заявления физического лица о применении процедуры банкротства от фронт системы",
        "bankruptcyType": "Тип процедуры банкротства",
        "statementApplicationDate": "Дата подачи заявления от фронт системы",
        "statementRegDate": "Дата регистрации заявления в системе Tazalau",
        "statementAcceptDate": "Дата принятия заявления/иска(дата публикации должника)",
        "refusalDate": "Дата отказа в применении процедуры",
        "proceedingsStartDate": "Дата возбуждения производства по делу",
        "courtDecisionDate": "Дата решения суда о применении процедуры судебного банкротства",
        "terminationDate": "Дата прекращения процедуры",
        "bankruptStartDate": "Дата признания банкротом ",
        "bankruptEndDate": "Дата завершения банкротства  ",
        "lastModificationDate": "Дата актуальности данных",
        "statementStatus": "Статус заявления физического лица",
        "rowVersion": "Версия актуальности данных",
        "citizenStatus": "Статус гражданина",
        "terminationReasons": [Причины прекращения процедуры],
        "bankruptEndReasons": [Причины завершения банкротства]
      }
    ]
  }
}`,
            },
        ],
    };
    const result = data[module];
    return Array.isArray(result) ? { services: result } : result;
};
